
export default {
  methods: {
    openMemberPreferences (member) {
      if (!member || !member.id) return
      this.selectedMemberPreferencesId = member.id
    }
  }
}
